// capstone/frontend/src/services/api.js


import axios from "axios";

const getBaseURL = () => {
  if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (window.location.hostname === "localhost") {
    return "http://localhost:5000/api";
  }

  if (window.location.hostname.endsWith("devtunnels.ms")) {
    const tunnelId = window.location.hostname.split("-")[0];
    return `https://${tunnelId}-5000.asse.devtunnels.ms/api`;
  }

  return process.env.REACT_APP_API_URL || "http://localhost:5000/api";
};

const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const APP_API_URL =
  process.env.NODE_ENV !== 'production' && window.location.hostname === "localhost"
    ? "http://localhost:5002/api"
    : (process.env.REACT_APP_APP_API_URL || "https://appapi.todago.site/api");

const appApi = axios.create({
  baseURL: APP_API_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

appApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const authAPI = {
  register: (data) => api.post("/auth/register", data),

  verifyPassword: (data) => api.post("/auth/verify-password", data),

  verifyEmail: (data) => api.post("/auth/verify-email", data),

  resendVerification: (data) => {
   
    const payload = typeof data === 'string' ? { email: data } : data;
    return api.post("/auth/resend-verification", payload);
  },

 
  sendPasswordChangeOTP: (data) => {
    const payload = typeof data === 'string' ? { email: data } : data;
    return api.post("/auth/send-password-change-otp", payload);
  },
  verifyPasswordChangeOTP: (data) =>
    api.post("/auth/verify-password-change-otp", data),
  
  resetPassword: (data) =>
    api.post("/auth/reset-password", data),

  login: (data) => api.post("/auth/login", data),
  verifyLoginOTP: (data) => api.post("/auth/verify-login-otp", data),
  logout: () => api.post("/auth/logout"),
  getMe: () => api.get("/auth/me"),
};

export const userAPI = {
  getAllUsers: (params) => api.get("/users", { params }),
  getUserById: (id) => api.get(`/users/${id}`),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  requestEmailChange: (id, data) => api.post(`/users/${id}/email-change/request`, data),
  confirmEmailChange: (id, data) => api.post(`/users/${id}/email-change/confirm`, data),
  changePassword: (id, data) => api.put(`/users/${id}/change-password`, data),
  toggle2FA: (id) => api.put(`/users/${id}/toggle-2fa`),
  deactivateUser: (id, data) => api.put(`/users/${id}/deactivate`, data || {}),
  reactivateUser: (id) => api.put(`/users/${id}/reactivate`),
  deleteUser: (id) => api.delete(`/users/${id}`),
  recoverUser: (id) => api.put(`/users/${id}/recover`),
  cancelUserDeletion: (id) => api.put(`/users/${id}/cancel-deletion`),
  getUserProfile: (id) => api.get(`/users/${id}`),
  getUserBookings: (id) => api.get(`/users/${id}/full-profile`),
  createAdmin: (data) => api.post('/users/create-admin', data),
  sendPhoneOTP: (id, phone) => api.post(`/users/${id}/send-phone-otp`, { phone }),
  verifyPhoneOTP: (id, data) => api.post(`/users/${id}/verify-phone-otp`, data),
  unlinkPhone: (id) => api.put(`/users/${id}/unlink-phone`),
};

export const driverAPI = {
  startIdentitySession: () => api.post('/drivers/identity-session', { privacyConsent: true }),
  checkStatus: (code) => api.get(`/drivers/status/${code}`),
  extractId: (file, sessionToken) => {
    const fd = new FormData();
    fd.append('license', file);
    fd.append('privacyConsent', 'true');
    return api.post('/drivers/extract-id', fd, { headers: { 'Content-Type': 'multipart/form-data', 'X-Driver-Verification-Session': sessionToken }, timeout: 60000 });
  },
  detectFaceAndId: (file, sessionToken) => {
    const fd = new FormData();
    fd.append('image', file);
    fd.append('privacyConsent', 'true');
    return api.post('/drivers/detect-face-id', fd, { headers: { 'Content-Type': 'multipart/form-data', 'X-Driver-Verification-Session': sessionToken }, timeout: 30000 });
  },
  verifyFaceEvidence: ({ driversLicense, selfieWithId, selfie, livenessChallenge, sessionToken }) => {
    const fd = new FormData();
    fd.append('driversLicense', driversLicense);
    fd.append('selfieWithId', selfieWithId);
    fd.append('selfie', selfie);
    fd.append('livenessChallenge', livenessChallenge);
    fd.append('privacyConsent', 'true');
    return api.post('/drivers/verify-face-evidence', fd, { headers: { 'Content-Type': 'multipart/form-data', 'X-Driver-Verification-Session': sessionToken }, timeout: 60000 });
  },
  resubmit: (code, formData) => api.put(`/drivers/resubmit/${code}`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 }),
};

export const analyticsAPI = {
  getAnalytics: (period = '7d') => api.get('/analytics', {
    params: { period, _fresh: Date.now() },
  }),
  getPublicStats: () => api.get('/analytics/public'),
  searchAdmin: (q) => api.get('/analytics/search', { params: { q } }),
  liveOps: () => api.get('/analytics/live-ops'),
};

export const configAPI = {
  getPresentationPrivacy: () => api.get('/config/presentation-privacy'),
  getBasemapConfig: () => api.get('/config/basemap'),
  getFareConfig: () => api.get('/config/fare'),
  updateFareConfig: (data) => api.put('/config/fare', data),
  getMapConfig: () => api.get('/config/map'),
  updateMapConfig: (data) => api.put('/config/map', data),
  deleteMapHistoryEntry: (savedAt) => api.delete(`/config/map/history/${encodeURIComponent(savedAt)}`),
  getRatingTags: () => api.get('/config/rating-tags'),
  updateRatingTags: (tags) => api.put('/config/rating-tags', { tags }),
  getPOIs: () => api.get('/config/pois'),
  savePOIs: (pois) => api.put('/config/pois', { pois }),
  getIdTypes: () => api.get('/config/id-types'),
  updateIdTypes: (idTypes) => api.put('/config/id-types', { idTypes }),
};

export const presentationPrivacyAPI = {
  getAccounts: (controlToken) => api.get('/config/presentation-accounts', {
    headers: { 'X-Presentation-Control-Token': controlToken },
  }),
  setAccounts: (enabled, expectedRevision, controlToken) => api.put('/config/presentation-accounts',
    { enabled, expectedRevision },
    { timeout: 60000, headers: { 'X-Presentation-Control-Token': controlToken } },
  ),
  fillAccountPhones: (expectedRevision, controlToken) => api.patch('/config/presentation-accounts/phones',
    { expectedRevision },
    { timeout: 60000, headers: { 'X-Presentation-Control-Token': controlToken } },
  ),
  getControl: (routeKey) => api.post('/config/presentation-privacy/control-entry', { routeKey }),
  unlock: (routeKey, passphrase) => api.post('/config/presentation-privacy/unlock', { routeKey, passphrase }),
  update: (enabled, controlToken) => api.put(
    '/config/presentation-privacy',
    { enabled },
    { headers: { 'X-Presentation-Control-Token': controlToken } },
  ),
};

export const auditLogAdminAPI = {
  getLogs: (params) => api.get('/audit-logs', { params }),
};

export const bookingAdminAPI = {
  getBookings: (page) => api.get(`/bookings?page=${page}&limit=10`),
  getByUser: (userId) => api.get(`/bookings/user/${userId}`),
  getByDriver: (driverId) => api.get(`/bookings/driver/${driverId}`),
};

export const serviceRequestAdminAPI = {
  getByUser: (userId) => api.get(`/service-requests/user/${userId}`),
  getByDriver: (driverId) => api.get(`/service-requests/driver/${driverId}`),
};

export const serviceTricycleAPI = {
  list: (status) => appApi.get('/service-requests/admin/service-tricycles', { params: status ? { status } : {} }),
  updateStatus: (id, status, note) => appApi.patch(`/service-requests/admin/service-tricycles/${id}`, { status, note }),
  listContracts: () => appApi.get('/service-requests/admin/service-contracts'),
  advanceBilling: (id, expectedDemoRevision) => appApi.post(`/service-requests/${id}/contract/demo-advance-billing`, { expectedDemoRevision }),
};

export const walletAdminAPI = {
  listTransactions: (params) => appApi.get('/payment/admin/transactions', { params }),
  getAccountTransactions: (userId, params) => appApi.get(`/payment/admin/accounts/${userId}/transactions`, { params }),
};

export const incidentAdminAPI = {
  list: (params) => appApi.get('/incidents/officer', { params }),
  update: (id, data) => appApi.patch(`/incidents/officer/${id}`, data),
};

export const policyAPI = {
  flags: () => api.get('/policy/flags'),
  run: () => api.post('/policy/run'),
  getPolicies: () => api.get('/policy/policies'),
  updatePolicies: (data) => api.put('/policy/policies', data),
};

export const newsAPI = {
  getPosts: () => api.get('/news'),
  getWebPosts: () => api.get('/news/web'),
  getWebPostById: (id) => api.get(`/news/web/${id}`),
  getAllPosts: () => api.get('/news/admin/all'),
  createPost: (data) => api.post('/news', data),
  updatePost: (id, data) => api.put(`/news/${id}`, data),
  deletePost: (id) => api.delete(`/news/${id}`),
  sendAnnouncement: (data) => appApi.post('/news/announce', data),
};

export const feedbackAPI = {
  list: (params) => api.get('/feedback', { params }),
  stats: () => api.get('/feedback/stats'),
  update: (id, data) => api.patch(`/feedback/${id}`, data),
  remove: (id) => api.delete(`/feedback/${id}`),
  exportCsv: (params) => api.get('/feedback/export.csv', { params, responseType: 'blob' }),
};

export const poiRequestAPI = {
  list: (params) => api.get('/poi-requests', { params }),
  approve: (id, data) => api.post(`/poi-requests/${id}/approve`, data || {}),
  reject: (id, data) => api.post(`/poi-requests/${id}/reject`, data || {}),
  remove: (id) => api.delete(`/poi-requests/${id}`),
};

export const aiAPI = {
  commentary: (chart, context, fresh = false) =>
    api.post('/ai/commentary', { chart, context, fresh }, { timeout: 45000 }),
  recommendations: (context, fresh = false) =>
    api.post('/ai/commentary', { chart: 'System Recommendations', context, fresh, mode: 'recommendations' }, { timeout: 45000 }),
};

export const reportAPI = {
  getUserReport: (id, period = '30d') => api.get(`/reports/user/${id}`, { params: { period } }),
  getDriverReport: (id, period = '30d') => api.get(`/reports/driver/${id}`, { params: { period } }),
};

export default api;
